import { IntlFormatters } from 'react-intl'
import * as yup from 'yup'

import { OTHER_FIELD_KEY } from '../additionalQuestionField'

export const generateSchema = (
  f: IntlFormatters['formatMessage'],
  additionalFields: string[] = [],
) => {
  const addtionalValidate: { [key in string]: any } = {}
  additionalFields.map((i) => {
    // @ts-ignore
    addtionalValidate[i] = yup.string().valIncludesStr(OTHER_FIELD_KEY, f)
  })
  return yup.object().shape({
    ...addtionalValidate,
  })
}

yup.addMethod(
  yup.string,
  'valIncludesStr',
  function (key: string, f: IntlFormatters['formatMessage']) {
    return this.test({
      name: 'valIncludesStr',
      message: f({
        id: 'additionalQuestion.inputErr.otherAnswerRequire',
        defaultMessage: 'Please fill your other answer',
      }),
      exclusive: false,
      test: (value: any) => !value.includes(key),
    })
  },
)
